/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

// WERZ web template. Mapped from Figma "Community / Web" (soPYlusCdGlDdV2lUIVdx3, 576:18822).

const base: CommunityData = {
  code: "base",
  inviteCode: "base",
  name: "Base",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/base`,
  socials: {},
  defaultCurrency: "SEK",
  styles: {
    global: {
      werzLogoColor: "#000000",
      // Square icon for the join gate's 96px circle, the claim card and the download page
      logo: {
        src: "https://media.werz.at/community-assets/base/community-icon.png",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/base/web-logo.png",
        styles: "w-[160px]",
      },
      // Figma "Popup / Prompt + Variable price" 1220:19463; ! beats ModalBase and input defaults
      modalWindow: {
        container: "!bg-[#EBEBEB] border border-[#A7A7A7] sm:!w-[512px] !max-w-[512px] !px-6 !py-8",
        title: "text-[#000000] !font-['InterRegular'] text-[24px] leading-[120%] tracking-normal",
        subtitle: "text-[#222222] text-[14px] leading-[120%] !font-['InterRegular']",
        input: {
          container:
            "!w-[180px] !h-[51px] bg-[#FFFFFF] border border-[#6D6D6D] !rounded-[8px] !pl-3 !pr-4 text-[#000000]",
          input: "!text-[16px] !leading-[120%] placeholder-[#000000]/50",
        },
        amountInput: {
          currency: "!pl-2 !text-[16px] !leading-[120%]",
        },
        button:
          "bg-[#000000] border border-[#000000] rounded-[8px] px-4 h-[48px] text-[#FFFFFF] text-[14px] leading-[100%]",
      },
      bgColor: "#B4B4B4",
      asideBg: "#BDBDBD",
      // Border-only aside, so item dividers run full width.
      asideStyles: "!p-0 sm:border-r border-[#8D8D8D]",
      contentBg: "#EBEBEB",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      mainFont: "font-['InterRegular']",
      scrollArrow: {
        background: "#000000",
        color: "#FFFFFF",
      },
      primaryButton:
        "bg-[#000000] border border-[#000000] rounded-[8px] px-[18px] py-4 !h-[48px] !w-fit !text-[#FFFFFF] !text-[16px] leading-[100%]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-[#8D8D8D]",
      separator: "",
      // Font named: checkout pages swap mainFont for font-mono and still show this menu.
      item: "text-[#222222] font-['InterRegular'] text-[16px] text-center leading-[100%] text-opacity-50 border-b border-[#8D8D8D] !pl-0 !py-4",
      itemSelected: "!text-opacity-100",
    },
    // Figma "Module / Landing / Desktop" 235:2068, "Mobile" 363:9081
    communityLanding: {
      container: "!mb-0 !pt-0",
      titles: "text-[#000000] font-['InterMedium'] text-[28px] leading-[120%]",
      emptyOrLoadingState: "!mx-4 sm:!mx-8 text-[#8D8D8D] text-[14px] leading-[120%]",
      announcementsV2: {
        sectionContainer: "!py-4 sm:!py-8 !m-0 space-y-0 border-b border-[#333333]",
        sectionTitle: "sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-6",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          // Figma "Card / News"
          container: "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative overflow-hidden",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-[#D9D9D9]",
          content: "flex flex-col pt-4",
          title: "text-[#000000] font-['InterMedium'] text-[18px] leading-[120%]",
          subtitle: "text-[#8D8D8D] text-[14px] leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 border-b border-[#333333]",
        sectionTitle: "pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] gap-6",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          // Figma "Event item"
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-48px)] sm:!w-[420px] h-full overflow-hidden",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-[#D9D9D9]",
          content: "flex flex-col pt-4 sm:pt-0 sm:pl-3",
          title: "text-[#000000] font-['InterMedium'] text-[18px] leading-[120%] sm:text-[16px]",
          location: "text-[#8D8D8D] text-[14px] leading-[120%] sm:text-[12px] mt-1",
          date: "text-[#8D8D8D] text-[14px] leading-[120%] sm:text-[12px] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !m-0 overflow-hidden",
        sectionTitle: "!mb-4 sm:!mb-6",
        title: "text-[#000000] text-[24px] leading-[120%]",
        text: "text-[#222222] text-[16px] leading-[120%]",
        // The image and the headline above the copy are both gated on customShopImage.
        customShopImage: "/assets/images/static-shop.png",
        customShopImageStyle: "!h-auto aspect-video sm:!w-[420px]",
      },
    },
    // Figma "Module / Event / Desktop" 987:17150, "Mobile" 367:2839, "Tickets" 235:8023
    eventV2: {
      container: "flex flex-col !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-8 sm:p-8 p-4 border-b border-[#333333]",
        media: "!h-auto aspect-video sm:!w-[320px] !border-0",
        title: "text-[#000000] text-[24px] sm:font-['InterMedium'] sm:text-[28px] leading-[120%]",
        subtitle: "text-[#8D8D8D] text-[14px] leading-[120%] mb-4 mt-2",
        questions:
          "text-[#8D8D8D] text-[14px] leading-[120%] mt-4 [&>a]:text-[#000000] [&>a]:font-normal [&>a]:underline",
        // Read unguarded next to global.primaryButton; unset it renders an "undefined" class
        button: "",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#333333]",
        header: "text-[#000000] text-[24px] leading-[120%]",
        text: "text-[#222222] text-[14px] leading-[120%]",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#333333]",
        header: "text-[#000000] text-[24px] leading-[120%]",
        text: "text-[#222222] text-[14px] leading-[120%]",
        map: "!h-auto aspect-video sm:!w-[350px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] text-[24px] leading-[120%] sm:mb-2",
        text: "text-[#222222] text-[16px] leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] text-[24px] leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-6 flex justify-between items-center",
        outerContainer: "flex flex-col !pb-8",
        innerContainer:
          "flex flex-col overflow-hidden px-4 sm:px-8 pb-4 sm:pb-8 border-b border-[#333333]",
        accessCode: {
          button:
            "bg-[#A7A7A7] border border-[#A7A7A7] rounded-[8px] px-4 py-[13px] text-[#000000] text-[14px] leading-[100%] !w-fit",
        },
        ticket: {
          // Media paints a black name tile for products without an image
          mediaContainer: "!hidden",
          name: "text-[#000000] font-['InterMedium'] text-[16px] leading-[120%]",
          description: "text-[#8D8D8D] text-[14px] leading-[120%] mt-1",
          price: "text-[#8D8D8D] font-['InterMedium'] text-[16px] leading-[120%] mt-1",
          descriptionCutoff: 30,
          quantity: "text-[#000000] text-[14px] leading-[100%]",
          status: "text-[#8D8D8D] font-['InterMedium'] text-[16px] leading-[120%]",
          counterContainer: "bg-[#A7A7A7] border-[#A7A7A7] rounded-[8px] px-4 !h-[44px] !w-fit",
          plusMinusColor: "#000000",
          button:
            "bg-[#A7A7A7] border border-[#A7A7A7] rounded-[8px] px-4 py-[13px] text-[#000000] text-[14px] leading-[100%] !w-fit",
          container:
            "flex justify-between items-start gap-x-4 py-4 overflow-hidden border-b border-[#8D8D8D] first:pt-0 last:pb-0 last:border-b-0",
        },
      },
    },
    // Figma "Module / Shop / Desktop" 1158:25303, "Mobile" 1434:19728
    shopV2: {
      // The grey stays: substation inherits shopV2 with an empty contentBg.
      container: "flex flex-col !pb-8 !bg-[#EBEBEB]",
      header:
        "text-[#000000] font-['InterMedium'] text-[28px] leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8",
      emptyState: "text-[#8D8D8D] text-[14px] leading-[120%] px-4 sm:px-8 pb-8",
      eventSection: {
        // first:!pt-0: the Shop header row already adds mb-9 above the first section
        container: "px-4 sm:px-8 py-4 sm:py-8 first:!pt-0 border-b border-[#333333]",
        // Required by the type; the event section renders no header.
        header: "",
        event: {
          container: "flex items-center gap-x-3 mb-6",
          dateBox:
            "bg-[#000000] border border-[#6D6D6D] rounded-[8px] w-[68px] h-[68px] flex flex-col items-center justify-center shrink-0 text-[#FFFFFF] font-['InterMedium'] text-[16px] leading-[120%]",
          details: "flex-1 min-w-0",
          name: "text-[#000000] font-['InterMedium'] text-[16px] leading-[120%]",
          date: "text-[#8D8D8D] text-[12px] leading-[120%] mt-2",
          location: "text-[#8D8D8D] text-[12px] leading-[120%] mt-1",
        },
        tickets: {
          container: "flex flex-col overflow-hidden",
          ticket: {
            container:
              "flex justify-between items-start gap-x-4 py-2 border-b border-[#8D8D8D] first:pt-0 last:pb-0 last:border-b-0",
            mediaContainer: "!hidden",
            name: "text-[#000000] font-['InterMedium'] text-[16px] leading-[120%]",
            description: "text-[#8D8D8D] text-[14px] leading-[120%] mt-1",
            price: "text-[#8D8D8D] font-['InterMedium'] text-[16px] leading-[120%] mt-1",
            descriptionCutoff: 30,
            quantity: "text-[#000000] text-[14px] leading-[100%]",
            status: "text-[#8D8D8D] font-['InterMedium'] text-[16px] leading-[120%]",
            counterContainer: "bg-[#A7A7A7] border-[#A7A7A7] rounded-[8px] px-4 !h-[44px] !w-fit",
            plusMinusColor: "#000000",
            button:
              "bg-[#A7A7A7] border border-[#A7A7A7] rounded-[8px] px-4 py-[13px] text-[#000000] text-[14px] leading-[100%] !w-fit",
          },
        },
      },
      membershipSection: {
        container: "px-4 sm:px-8 py-4 sm:py-8 first:!pt-0 border-b border-[#333333]",
        header: "text-[#000000] text-[24px] leading-[120%] mb-6",
        products: {
          container: "flex flex-col overflow-hidden",
          product: {
            container:
              "flex justify-between items-start gap-x-4 py-2 border-b border-[#8D8D8D] first:pt-0 last:pb-0 last:border-b-0",
            mediaContainer: "!hidden",
            name: "text-[#000000] font-['InterMedium'] text-[16px] leading-[120%]",
            description: "text-[#8D8D8D] text-[14px] leading-[120%] mt-1",
            price: "text-[#8D8D8D] font-['InterMedium'] text-[16px] leading-[120%] mt-1",
            descriptionCutoff: 30,
            button:
              "bg-[#000000] border border-[#000000] rounded-[8px] px-4 py-[13px] text-[#FFFFFF] text-[14px] leading-[100%] !w-fit",
          },
        },
      },
      merchSection: {
        container: "px-4 sm:px-8 py-4 sm:py-8 first:!pt-0 border-b border-[#333333]",
        header: "text-[#000000] text-[24px] leading-[120%] mb-6",
        products: {
          container: "grid grid-cols-2 sm:grid-cols-3 gap-x-4 sm:gap-x-6 gap-y-6",
          product: {
            container: "cursor-pointer overflow-hidden",
            innerContainer: "flex flex-col",
            mediaContainer: "overflow-hidden",
            media: "!aspect-square !border-0",
            name: "text-[#000000] font-['InterMedium'] text-[16px] leading-[120%] mt-3",
            description: "text-[#8D8D8D] text-[12px] leading-[120%] mt-1",
            // Figma centres the price against a hidden counter.
            price: "text-[#8D8D8D] font-['InterMedium'] text-[16px] leading-[120%] mt-2.5",
            descriptionCutoff: 30,
          },
        },
      },
    },
    // Figma "Module / Shop / Subscription" 1278:19158, "Merch - size + color" 1413:19095,
    // "Merch - one-size" 1413:20576
    shopProductV2: {
      // The grey stays: substation inherits shopProductV2 with an empty contentBg.
      container: "flex flex-col !bg-[#EBEBEB] overflow-hidden sm:p-8 p-4",
      mediaContainer: "overflow-hidden",
      media: "!aspect-video !border-0",
      title: "text-[#000000] font-['InterMedium'] text-[28px] leading-[120%] mt-6",
      additionalDetails: "text-[#222222] text-[16px] leading-[120%] mt-6 pb-2 sm:max-w-[595px]",
      priceSection: "border-t border-[#8D8D8D] mt-2 pt-2",
      displayPrice: "text-[#222222] font-['InterMedium'] text-[16px] leading-[120%]",
      shortTerms: "text-[#8D8D8D] text-[14px] leading-[120%] mt-1",
      variantSelector: {
        section: "mt-2 sm:mt-4 space-y-2",
        separator: "flex items-center justify-between gap-x-[10px] border-t border-[#8D8D8D] pt-2",
        label: "text-[#222222] text-[14px] leading-[120%]",
        sizeButton:
          "px-3 py-[10px] border border-transparent text-[#000000] rounded-[8px] text-[12px] leading-[100%] transition-all",
        sizeButtonSelected:
          "px-3 py-[10px] border border-[#000000] text-[#000000] rounded-[8px] text-[12px] leading-[100%]",
        sizeButtonOneSize:
          "px-3 py-[10px] border border-[#000000] text-[#000000] rounded-[8px] text-[12px] leading-[100%]",
        colorSwatchContainer: "flex gap-x-[10px] items-center",
        colorSwatch: "w-8 h-8 rounded-full border border-[#000000] transition-all",
        colorSwatchSelected: "w-8 h-8 rounded-full border-2 border-[#000000] transition-all",
      },
      counter: {
        container: "bg-[#A7A7A7] border-[#A7A7A7] rounded-[8px] px-4 !h-[44px]",
        quantity: "text-[#000000] text-[14px] leading-[100%]",
        plusMinusColor: "#000000",
      },
      button:
        "bg-[#000000] border border-[#000000] rounded-[8px] px-[18px] py-4 !h-[48px] !w-fit !text-[#FFFFFF] !text-[16px] leading-[100%] self-center",
    },
    // Figma "Linkz" 576:35333: Desktop / Landing 576:35331, Mobile / Landing 2031:22800
    // No mainFont on /l, so the links styles name InterRegular
    linktree: {
      bgDesktop: "",
      bgMobile: "",
      bgColor: "#EBEBEB",
      container: "flex flex-col items-center min-h-screen pt-16",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[#A7A7A7] object-cover",
        name: "text-[#000000] font-['InterMedium'] text-[28px] leading-[120%] text-center mt-2",
        location:
          "text-[#8D8D8D] font-['InterMedium'] text-[18px] leading-[120%] text-center mt-2 empty:hidden",
        description:
          "text-[#222222] font-['InterRegular'] text-[14px] leading-[120%] text-center my-4 empty:hidden",
        socialMediaIconColor: "#000000",
        button:
          "flex justify-center items-center bg-[#000000] border border-[#000000] rounded-[8px] px-4 py-[13px] text-[#FFFFFF] font-['InterRegular'] text-[14px] leading-[100%] cursor-pointer",
      },
      upcomingEvents: {
        // Figma has no title above the event card (the Links / Shop toggle sits there).
        header: "hidden",
        container: "sm:w-[500px] w-[calc(100vw-32px)] flex flex-col items-center overflow-hidden",
        loadingState:
          "mb-8 h-[56px] sm:w-[500px] w-[calc(100vw-32px)] px-4 flex items-center bg-[#EBEBEB] border border-[#A7A7A7] text-[#8D8D8D] font-['InterRegular'] text-[14px] leading-[120%]",
        emptyState: {
          container:
            "sm:w-[500px] w-[calc(100vw-32px)] flex flex-col justify-center items-center p-8 mb-8 bg-[#EBEBEB] border border-[#A7A7A7]",
          title: "text-[#000000] font-['InterMedium'] text-[18px] leading-[120%] text-center mb-1",
          text: "text-[#222222] font-['InterRegular'] text-[14px] leading-[120%] text-center",
          button:
            "flex justify-center items-center bg-[#000000] border border-[#000000] rounded-[8px] px-4 py-[13px] text-[#FFFFFF] font-['InterRegular'] text-[14px] leading-[100%] cursor-pointer mt-4",
        },
        collapsedEvent: {
          container:
            "cursor-pointer sm:w-[500px] w-[calc(100vw-32px)] flex justify-between items-center py-2 border-b border-[#8D8D8D]",
          media: "overflow-hidden mr-3 shrink-0",
          name: "text-[#000000] font-['InterMedium'] text-[18px] leading-[120%] one-line-truncate",
          duration: "text-[#8D8D8D] font-['InterRegular'] text-[12px] leading-[120%]",
          plusIconColor: "#000000",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[calc(100vw-32px)] mb-2 bg-[#EBEBEB] border border-[#A7A7A7]",
          // The month/day <p>s hard-code their sizes; these override them.
          startDate:
            "w-[68px] h-[68px] rounded-[8px] bg-[#000000] border border-[#6D6D6D] text-[#FFFFFF] flex flex-col justify-center items-center font-['InterMedium'] [&>p]:!text-[16px] [&>p]:!leading-[120%]",
          name: "text-[#000000] font-['InterMedium'] text-[18px] leading-[120%] mb-2",
          duration: "text-[#8D8D8D] font-['InterRegular'] text-[12px] leading-[120%]",
          location: "text-[#8D8D8D] font-['InterRegular'] text-[12px] leading-[120%] mt-1",
          product: {
            container: "min-h-[69px] p-4 flex justify-between gap-4 border-t border-[#8D8D8D]",
            name: "text-[#000000] font-['InterMedium'] text-[16px] leading-[120%]",
            price: "text-[#8D8D8D] font-['InterRegular'] text-[12px] leading-[120%] mt-1",
            link: "text-[#8D8D8D] font-['InterRegular'] text-[12px] leading-[120%] mt-1",
            status: "text-[#8D8D8D] font-['InterRegular'] text-[12px] leading-[120%]",
            button:
              "flex justify-center items-center bg-[#A7A7A7] border border-[#A7A7A7] rounded-[8px] px-3 py-[10px] text-[#000000] font-['InterRegular'] text-[12px] leading-[100%] cursor-pointer",
          },
        },
        // The card and the last collapsed row already have 8px below them.
        seeAllEvents:
          "w-full text-[#222222] font-['InterRegular'] text-[14px] leading-[120%] underline cursor-pointer mb-8 mt-2",
      },
      news: {
        header:
          "sm:w-[500px] w-[calc(100vw-32px)] text-[#000000] font-['InterMedium'] text-[18px] leading-[120%] mb-4",
        container: "",
        loadingState:
          "mb-8 h-[56px] sm:w-[500px] w-[calc(100vw-32px)] px-4 flex items-center bg-[#EBEBEB] border border-[#A7A7A7] text-[#8D8D8D] font-['InterRegular'] text-[14px] leading-[120%]",
        // News, radio and link rows are siblings: no padding above the first or below the last
        oneNews: {
          container:
            "cursor-pointer sm:w-[500px] w-[calc(100vw-32px)] flex justify-between items-center py-2 border-b border-[#8D8D8D] first:pt-0 last:pb-0 last:border-b-0",
          media: "overflow-hidden mr-3 shrink-0",
          name: "text-[#000000] font-['InterMedium'] text-[18px] leading-[120%] one-line-truncate",
          created: "text-[#8D8D8D] font-['InterRegular'] text-[12px] leading-[120%]",
          triangleIconColor: "#000000",
        },
        seeAllNews:
          "w-full text-[#222222] font-['InterRegular'] text-[14px] leading-[120%] underline cursor-pointer mb-8 mt-4",
      },
      radioTracks: {
        header:
          "sm:w-[500px] w-[calc(100vw-32px)] text-[#000000] font-['InterMedium'] text-[18px] leading-[120%] mb-4",
        container: "",
        loadingState:
          "mb-8 h-[56px] sm:w-[500px] w-[calc(100vw-32px)] px-4 flex items-center bg-[#EBEBEB] border border-[#A7A7A7] text-[#8D8D8D] font-['InterRegular'] text-[14px] leading-[120%]",
        radioTrack: {
          container:
            "cursor-pointer sm:w-[500px] w-[calc(100vw-32px)] flex justify-between items-center py-2 border-b border-[#8D8D8D] first:pt-0 last:pb-0 last:border-b-0",
          coverUrl: "overflow-hidden mr-3 shrink-0",
          title: "text-[#000000] font-['InterMedium'] text-[18px] leading-[120%] one-line-truncate",
          duration: "text-[#8D8D8D] font-['InterRegular'] text-[12px] leading-[120%]",
          start: "text-[#2ACE2A] font-['InterRegular'] text-[12px] leading-[120%]",
          liveType: "text-[#ED3737] font-['InterRegular'] text-[12px] leading-[120%]",
          liveTypeCircle: "w-[6px] h-[6px] rounded-full bg-[#ED3737]",
          playIconColor: "#FFFFFF",
          playIconBackgroundColor: "#000000",
          playIconBorderColor: "#000000",
        },
        seeAllTracks:
          "w-full text-[#222222] font-['InterRegular'] text-[14px] leading-[120%] underline cursor-pointer mb-8 mt-4",
      },
      otherLinks: {
        header:
          "sm:w-[500px] w-[calc(100vw-32px)] text-[#000000] font-['InterMedium'] text-[18px] leading-[120%] mb-4",
        container: "",
        loadingState:
          "mb-8 h-[56px] sm:w-[500px] w-[calc(100vw-32px)] px-4 flex items-center bg-[#EBEBEB] border border-[#A7A7A7] text-[#8D8D8D] font-['InterRegular'] text-[14px] leading-[120%]",
        link: {
          container:
            "cursor-pointer sm:w-[500px] w-[calc(100vw-32px)] flex justify-between items-center py-2 border-b border-[#8D8D8D] first:pt-0 last:pb-0 last:border-b-0",
          circleIcon: "w-[32px] h-[32px] rounded-full object-cover",
          name: "text-[#000000] font-['InterMedium'] text-[18px] leading-[120%]",
          triangleIconColor: "#000000",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
      },
    },
  },
}

export default base
